import { render, staticRenderFns } from "./OurProductsPage.vue?vue&type=template&id=c3817eea&scoped=true&"
import script from "./OurProductsPage.vue?vue&type=script&lang=js&"
export * from "./OurProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3817eea",
  null
  
)

export default component.exports